import { DesktopNavLink } from "./DesktopNavLink/DesktopNavLink";
import { navLinks } from "components/modules/Navigation/navLinks";
import UserAccountMenu from "../Navbar/Account/UserAccountMenu";

interface DesktopNavigationProps {
    isEditor: boolean;
}

export const DesktopNavigation = ({ isEditor }: DesktopNavigationProps) => {
    return (
        <ul className="hidden lg:flex items-center justify-between w-full">
            <div className="flex items-center">
                {navLinks.map((e, index) => (
                    <DesktopNavLink key={index} {...e} isEditor={isEditor} />
                ))}
            </div>
            <li>
                <UserAccountMenu />
            </li>
        </ul>
    );
};
